module.exports = __webpack_public_path__ + "img/shared-blue.a0f436eb.svg";